import { render, staticRenderFns } from "./trainingsHubTour.vue?vue&type=template&id=2fe01c04&scoped=true"
import script from "./trainingsHubTour.vue?vue&type=script&lang=js"
export * from "./trainingsHubTour.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubTour.vue?vue&type=style&index=0&id=2fe01c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe01c04",
  null
  
)

export default component.exports